var React = require('react');

function BagIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#fff}"),React.createElement("path",{"d":"M15.4 5c-.3-2.8-2.6-5-5.4-5S4.8 2.3 4.6 5H1v18.9h18V5h-3.6zM10 1.1c2.3 0 4.1 1.7 4.4 3.9H5.6c.2-2.2 2.1-3.9 4.4-3.9zm8 21.8H2V6h16v16.9z","key":1}),React.createElement("path",{"className":"st0","d":"M-13.2-1.8h10.8v4.6h-10.8z","key":2}),React.createElement("path",{"d":"M-1.9 3.2h-11.8v-5.5h11.8v5.5zm-10.8-.9h9.8v-3.6h-9.8v3.6z","key":3}),React.createElement("path",{"className":"st0","d":"M2 6h16v16.9H2z","key":4})]);
}

BagIcon.defaultProps = {"version":"1.1","x":"0","y":"0","viewBox":"0 0 20 24","xmlSpace":"preserve"};

module.exports = BagIcon;

BagIcon.default = BagIcon;
